import { navigationNames } from '@booking-portal/router/router-constants';
import { useAuthStore } from '@booking-portal/stores/auth-store';
import type { NavigationGuardWithThis } from 'vue-router';

export const isAuthenticatedGuard: NavigationGuardWithThis<unknown> = (
  to,
  from,
  next
) => {
  const authStore = useAuthStore();

  if (authStore.isLoggedIn) {
    next();
  } else {
    next({ name: navigationNames.login });
  }
};
